// Firebase Functions configuration
const getFirebaseFunctionsUrl = () => {
  // Check if we're using emulator mode
  const useEmulator = import.meta.env.VITE_USE_EMULATOR === 'true';
  
  console.log('🔧 Firebase Functions Config:', {
    VITE_USE_EMULATOR: import.meta.env.VITE_USE_EMULATOR,
    useEmulator,
    VITE_FIREBASE_PROJECT_ID: import.meta.env.VITE_FIREBASE_PROJECT_ID
  });
  
  if (useEmulator) {
    // For emulator mode, use local functions URL
    const emulatorUrl = 'http://localhost:5001/work-order-managment/europe-west1';
    console.log('🔧 Using emulator URL:', emulatorUrl);
    return emulatorUrl;
  }
  
  // For production, use the actual Firebase Functions URL
  const projectId = import.meta.env.VITE_FIREBASE_PROJECT_ID || 'work-order-managment';
  const liveUrl = `https://europe-west1-${projectId}.cloudfunctions.net`;
  console.log('🔧 Using live URL:', liveUrl);
  return liveUrl;
};

export const FIREBASE_FUNCTIONS_URL = getFirebaseFunctionsUrl();

// Function endpoints
export const FUNCTION_ENDPOINTS = {
  GENERATE_PM_WORK_ORDERS_TEST: `${FIREBASE_FUNCTIONS_URL}/generatePMWorkOrdersTest`,
  GENERATE_PM_WORK_ORDERS: `${FIREBASE_FUNCTIONS_URL}/generatePMWorkOrders`,
  DEACTIVATE_ASSET: `${FIREBASE_FUNCTIONS_URL}/deactivateAsset`,
  TEST_GET_WORK_ORDERS: `${FIREBASE_FUNCTIONS_URL}/testGetWorkOrders`,
  DELETE_USER: `${FIREBASE_FUNCTIONS_URL}/deleteUser`,
  GET_USERS_WITH_AUTH: `${FIREBASE_FUNCTIONS_URL}/getUsersWithAuth`,
  CREATE_USER: `${FIREBASE_FUNCTIONS_URL}/createUser`,
  CREATE_DEVICE_SESSION: `${FIREBASE_FUNCTIONS_URL}/createDeviceSession`,
  GET_DEVICE_SESSIONS: `${FIREBASE_FUNCTIONS_URL}/getDeviceSessions`,
  UPDATE_DEVICE_SESSION: `${FIREBASE_FUNCTIONS_URL}/updateDeviceSession`,
  DELETE_DEVICE_SESSION: `${FIREBASE_FUNCTIONS_URL}/deleteDeviceSession`,
  DELETE_ALL_USER_SESSIONS: `${FIREBASE_FUNCTIONS_URL}/deleteAllUserSessions`,
  SIGNUP: `${FIREBASE_FUNCTIONS_URL}/signup`,
} as const;
